
<template>
  <th
    v-show="!column.hideColumn"
    :class="[
      {
        'header-cell--active': active,
        'header-cell--sortable' : column.sortable,
      },
      `has-text-${column.align || 'left'}`
    ]"
    :style="{width: cellWidth}"
    class="header-cell has-text-weight-medium is-uppercase"
    @click="column.sortable && $emit('onSort')"
  >
    <span
      v-if="!column.hiddenHeader && !selectable"
      :style="column.align === 'right' && { flexDirection: 'row-reverse' }"
      class="cell-title is-flex align-center"
    >
      {{ $t(`views.${namespace}.table.${column.name}`) }}
      <span
        v-if="column.sortable"
        :class="column.order > 0 ? 'asc' : 'desc'"
        :style="{
          marginLeft: column.align !== 'right' && column.align !== 'center' ? '4px' : '0px',
          marginRight: column.align === 'right' ? '4px' : '0px'
        }"
        class="arrow"
      />
    </span>
    <CheckBox
      v-if="selectable && column.name === 'selectRow'"
      v-model:checked="selectAllCheckbox"
      :size="18"
      name="select_all_rows_check"
      appearance="secondary"
      checkmark-size="little"
      rounded
      @change="$emit('selectedAll', selectAllCheckbox)"
    />
  </th>
</template>

<script>

import CheckBox from '@/components/checkbox/CheckBox.vue';

export default {
  name: 'HeaderCell',
  components: {
    CheckBox,
  },
  props: {
    selectable: { type: Boolean, default: false },
    column: { type: Object, default: () => {} },
    active: { type: Boolean, default: false },
    namespace: { type: String, required: true },
    allRowsSelected: { type: Boolean, default: false },
  },
  emits: ['onSort', 'selectedAll'],
  data() {
    return {
      selectAllCheckbox: false,
    };
  },
  computed: {
    cellWidth() {
      if (this.column.width) return this.column.width;
      switch (this.column.type) {
        case 'date':
          return '80px';
        case 'currency':
          return '125px';
        case 'quantity':
          return '130px';
        case 'percentage':
          return '70px';
        default:
          return null;
      }
    },
  },
  watch: {
    allRowsSelected(newVal) {
      this.selectAllCheckbox = newVal;
    },
  },
  methods: {
  },
};
</script>

<style lang="scss">


.header-cell{

  &:first-child {
    padding-left:1rem;
  }

  &:last-child {
    padding-right:1rem;
  }

  font-size: $size-12;
  font-weight: $weight-medium;
  &--sortable{
    cursor: pointer;
  }
  &.header-cell--active .arrow {
    opacity: 1;
  }

  .arrow {
    display: inline-block;
    vertical-align: middle;
    width: 0;
    height: 0;
    top: 5px;
    right: -13px;
    opacity: 0.3;
    border-left: 0.3rem solid transparent;
    border-right: 0.3rem solid transparent;
    &.asc {
      border-bottom: 0.3rem solid $blue-steel;
    }
    &.desc {
      border-top: 0.3rem solid $blue-steel;
    }
  }

  .cell-title {
    position: relative;
  }
}


</style>
